import type { PageResponse } from './common'

export type InventoryMovementType =
  | 'MANUAL_ADJUSTMENT'
  | 'PURCHASE_RECEIPT'
  | 'RESERVE_FOR_WORK_ORDER'
  | 'RELEASE_RESERVATION'
  | 'CONSUME_FOR_REPAIR'
  | 'STOCK_OUT'
  | 'STOCK_IN'

export interface InventoryItem {
  id: number
  skuCode: string
  partName: string
  specification?: string
  unit: string
  warehouseCode: string
  onHandQty: number
  reservedQty: number
  availableQty: number
  safetyStockQty: number
  ledgers?: InventoryLedger[]
  relatedWorkOrders?: RelatedWorkOrder[]
  purchaseHistory?: PurchaseHistoryItem[]
  supplierInsight?: SupplierInsight | null
}

export interface InventoryLedger {
  id: number
  movementType: InventoryMovementType
  referenceType: string
  referenceId: number
  deltaOnHand: number
  deltaReserved: number
  beforeOnHand: number
  afterOnHand: number
  beforeReserved: number
  afterReserved: number
  remark: string
  createdAt: string
}

export interface RelatedWorkOrder {
  workOrderId: number
  workOrderNo: string
  hospitalName?: string
  deviceName?: string
  status: string
  requiredQty: number
  reservedQty: number
  consumedQty: number
  createdAt?: string
}

export interface PurchaseHistoryItem {
  purchaseOrderId: number
  purchaseNo: string
  supplierName: string
  status: string
  quantity: number
  receivedQty: number
  createdAt?: string
}

export interface SupplierInsight {
  supplierName: string
  purchaseCount: number
  lastPurchaseAt?: string
}

export interface CreateInventoryItemRequest {
  skuCode: string
  partName: string
  specification?: string
  unit: string
  warehouseCode: string
  safetyStockQty: number
}

export interface AdjustInventoryRequest {
  deltaOnHand: number
  remark: string
}

export interface LowStockAlert {
  skuCode: string
  partName: string
  currentQty: number
  safetyStockQty: number
  shortage: number
  level: 'critical' | 'warning'
}

export interface InventoryPageParams {
  keyword?: string
  lowStockOnly?: boolean
  page?: number
  size?: number
}

export type InventoryPageResponse = PageResponse<InventoryItem>

export const INVENTORY_MOVEMENT_LABELS: Record<InventoryMovementType, string> = {
  MANUAL_ADJUSTMENT: '手动调整',
  PURCHASE_RECEIPT: '采购入库',
  RESERVE_FOR_WORK_ORDER: '工单预留',
  RELEASE_RESERVATION: '释放预留',
  CONSUME_FOR_REPAIR: '维修消耗',
  STOCK_OUT: '出库',
  STOCK_IN: '入库',
}
